module.exports = __webpack_public_path__ + "static/media/pallet-alt.7a72a447.svg";